import { parseStatuses } from '../../../utils';
import { IAddToCartResult } from '../model';

import { getSettings } from './getSettings';
import { createNotification, getFatalErrors } from './helpers';

export const addToCartResult = ({
  response,
  showAddToCartModal,
  disableRedirect,
  products,
}: IAddToCartResult) => {
  const cartSettings = getSettings(showAddToCartModal, disableRedirect);
  const fatalErrors = getFatalErrors(response.productAddResponse);

  const productById = (id: string) =>
    response.productAddResponse.find((p) => String(p.productId) === id);

  if (fatalErrors.length === 0) {
    const statusMessages = products
      .map((product) => {
        const { productIncrease } = productById(product.id);

        return parseStatuses(
          response.serviceAddResponse,
          productIncrease,
          product.count
        );
      })
      .flat();

    return {
      success: true,
      cartSettings,
      statusMessages,
    };
  }

  const notificationMessages = createNotification(products, productById);

  return {
    success: false,
    errorCode: fatalErrors[0],
    cartSettings,
    notification: notificationMessages[0],
  };
};
